var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-m"},[_c('div',{staticClass:"centered"},[_c('h2',[_vm._v(_vm._s(_vm.t("Sign Up Complete")))]),_c('p',[_vm._v(_vm._s(_vm.t("We are forwarding you to your plan...")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }